import { render, staticRenderFns } from "./TaskAssignedTeam.vue?vue&type=template&id=2170b2c6&"
import script from "./TaskAssignedTeam.vue?vue&type=script&lang=js&"
export * from "./TaskAssignedTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports